<script>

    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {string} [as]
     * @property {any} label
     * @property {any} [icon]
     */
    let { as = 'div', label, icon = null } = $props();

    const dispatch = createEventDispatcher();
</script>

<svelte:element this={as} class="dynamic-title" onclick={() => dispatch('click')}>
    {#if icon}
        <i class="material-icons" aria-hidden="true">{icon}</i>
    {/if}
    <span>{label}</span>
</svelte:element>

<style>
    .dynamic-title {
        position:relative;
        box-sizing: border-box;
        width:100%;
        display:flex;
        flex-direction:row;
        align-items:center;
        justify-content: flex-start;
        border-bottom:1px solid rgba(255, 255, 255, 0.6);
        margin-bottom:0.75rem;
        padding:0 0 0.25rem;
    }

    .dynamic-title span {
        text-transform: uppercase;
        font-weight:600;
        font-size:0.75rem;
        color:rgba(255, 255, 255, 0.6);
        
    }

    .dynamic-title i {
        font-size:1.2rem;
        margin-right:0.5rem;
        color:rgba(255, 255, 255, 0.6);
    }

</style>